import React, { useState } from "react";
import Grid from "styled-components-grid";
import Input from "../UI/Form/Input";
import styled from "styled-components";

export default function StadiumEdit({ stadium, onChange }) {
  function updateStadium(stadium) {
    onChange(stadium);
  }

  return (
    <Grid style={{ width: "100%" }}>
      <Grid.Unit size={1 / 1}>
        <Input
          value={stadium.name || stadium.opta_name}
          title="Name"
          onChange={(e) => {
            let newStadium = { ...stadium, name: e.target.value };
            updateStadium(newStadium);
          }}
        />
      </Grid.Unit>
    </Grid>
  );
}
